<template>
  <m-geo-box geo-option="city">
    <m-geo-select :geoType="4" :changeGeoType="4"></m-geo-select>
  </m-geo-box>
</template>

<script>
  import MGeoBox from '@/components/geo/MGeoBox'
  import MGeoSelect from '@/components/geo/MGeoSelect'
  export default {
    components: {
      MGeoBox,
      MGeoSelect
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/order/GeoCity.vue